module.exports = {
    SIEAU_TOKEN: 'sieau-token',
    MODEL_EXPORT: 0,
    CSV_EXPORT: 1,
    EXCEL_EXPORT: 2,
    CEMAGREF_EXPORT: 3,
    EXPORT_TYPE_OPTIONS: [
        { value: 0, name: 'Modèles' },
        { value: 1, name: 'CSV' },
        { value: 2, name: 'Excel' },
    ],
    EXPORT_TYPE_OPTIONS_QUALITY: [
        { value: 0, name: 'Modèles' },
        { value: 1, name: 'CSV' },
        { value: 2, name: 'Excel' },
        { value: 3, name: 'CEMAGREF' },
    ],
    EXPORT_STATIONS_MEASURES: 'stationsMeasures',
    EXPORT_STATIONS_MODELS: 'stationsModels',
    EXPORT_JOB_ID_ONE_OFF: -2, // job d'export ponctuel (non programmé) — défaut côté back
    EXPORT_JOB_ID_SCHEDULED: -20, // job d'export programmé — défaut côté back
    EXPORT_TMP_QUALITY_REASEARCH: 'qualityResearch',
    EXPORT_CEMAGREF_CONST: 'cemagref',
    EXPORT_JOB_STATUS: {
        WAITING: 1,
        IN_PROGRESS: 2,
        FINISHED: 3,
        ERROR: 4,
    },
    LIMIT_CELL_LENGTH: 32767, // Character limit defined by the back library
}
